/**
 * @generated SignedSource<<b324acd95fd55e25c2a4a2848ba03ca8>>
 * @relayHash f768060f53d4f78eafce7fc0ce23db80
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-commerce/458.0.0-2024-04-17T06:58:39.973Z/useStripePromiseQuery

import { ConcreteRequest, Query } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type useStripePromiseQuery$variables = {
  currency: Currency;
};
export type useStripePromiseQuery$data = {
  readonly viewer: {
    readonly stripeClientToken: {
      readonly value: string | null;
    } | null;
  };
};
export type useStripePromiseQuery = {
  response: useStripePromiseQuery$data;
  variables: useStripePromiseQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "currency"
  }
],
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "currency",
      "variableName": "currency"
    }
  ],
  "concreteType": "Token",
  "kind": "LinkedField",
  "name": "stripeClientToken",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useStripePromiseQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useStripePromiseQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-commerce/458.0.0-2024-04-17T06:58:39.973Z/useStripePromiseQuery",
    "metadata": {},
    "name": "useStripePromiseQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "75c5444d442744f89e03dda4c44653e1";

export default node;
